import { colors } from '../../colors/colors';
import { ESRI_HIGHLIGHT_FILL_OPACITY } from '../configurations';

/**
 * The hover border for the redesigned event icon. Esri's highlight outlines every pixel an icon
 * paints, and the redesigned icon's drop shadow paints a soft square around the diamond, so a
 * hovered event gets this diamond drawn over it instead.
 *
 * It shares the event SVGs' canvas, so at the same symbol size it lines up with the diamond.
 */
export const EVENT_ICON_VIEW_BOX = '-1 -4.85 50 50';

export const EVENT_DIAMOND_CENTER = { x: 23.97, y: 20.15 };

/** Center to corner, along an axis, of the outer edge of the icon's white outline. */
export const EVENT_DIAMOND_OUTLINE_RADIUS = 19.8;

/** Width of the border's stroke, centered on its path. Tucks just under the white outline. */
export const EVENT_HOVER_BORDER_WIDTH = 2.7;

/** Center to corner of the border's path. */
export const EVENT_HOVER_BORDER_RADIUS = 21.3;

function round(value: number): number {
    return Number(value.toFixed(2));
}

function toDiamondPath(radius: number): string {
    const { x, y } = EVENT_DIAMOND_CENTER;
    return [
        `M${round(x)} ${round(y - radius)}`,
        `L${round(x + radius)} ${round(y)}`,
        `L${round(x)} ${round(y + radius)}`,
        `L${round(x - radius)} ${round(y)}`,
        'Z',
    ].join('');
}

const highlightColor = `rgb(${colors.esriColors.highlightColor.join(', ')})`;

export const EVENT_HOVER_OUTLINE_SVG = [
    `<svg width="50" height="50" viewBox="${EVENT_ICON_VIEW_BOX}" fill="none" xmlns="http://www.w3.org/2000/svg">`,
    `<path d="${toDiamondPath(EVENT_HOVER_BORDER_RADIUS)}"`,
    ` fill="${highlightColor}" fill-opacity="${ESRI_HIGHLIGHT_FILL_OPACITY}"`,
    ` stroke="${highlightColor}" stroke-width="${EVENT_HOVER_BORDER_WIDTH}" stroke-linejoin="round"/>`,
    '</svg>',
].join('');
